import React, { useContext, useEffect, useState } from "react";
import { GreetingsType, GreetingItem, GreetingTypes } from "../../../models/SKArtifact";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../utils/stringFunctions";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";

interface PopoverProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: () => void;
}

const SelectGreetingType = ({ isOpen, onClose, onSelect }: PopoverProps) => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<GreetingItem | null>(null);
  const { contentData, updateContentData } = useContext(CreateArtifactContext);

  const handleTypeSelect = (item: GreetingItem) => {
    setSelectedType(item);
  };

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [isOpen, onClose]);

  const handleSelect = async () => {
    if (selectedType) {
      updateContentData({ greetingType: selectedType.greetingType, cardImageURL: selectedType.serverUrl });
      setTimeout(() => {
        onSelect();
      }, 1);
    }
  };

  return (
    <div className={`fixed z-50 inset-0 flex items-center justify-center ${isOpen ? "visible" : "hidden"}`}>
      <div className="absolute inset-0 bg-black opacity-25"></div>
      <div id="main_screen" className="relative z-10 bg-white rounded-xl shadow-lg w-[540px] h-[589px] overflow-hidden">
        <div className="pl-[30px] pr-[30px] pt-[30px]">
          <p className="content_title">Choose Greeting Card</p>
          <p className="notes-class">Choose a design to add title and message.</p>
          <div className="bg-white max-h-[380px] max-w-[540px] mb-[5px] overflow-y-auto">
            <div id="ImageArea" className="flex flex-wrap justify-start gap-[15px] align-middle">
              {GreetingTypes.map((data, index) => (
                <div
                  onClick={() => handleTypeSelect(data)}
                  key={index}
                  className={`flex flex-col text-center w-[150px] h-[150px] items-center mb-4 rounded-xl border-[1px] ${
                    selectedType?.greetingType === data.greetingType ? "border-black border-[2px]" : "border-[#78788033] border-[2px]"
                  }`}
                >
                  <img src={data.greetingImgSrc} alt={data.greetingType} className="h-[150px] w-[150px] rounded-xl border-[1px]" />
                  <span className="location_list_title w-full text-left mt-[5px]">{capitalizeFirstLetter(data.greetingName)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="thickseparator" />
        <div id="action_btn" className="flex items-center justify-between m-[30px]">
          <button
            className="px-4 py-2 w-[113px] h-[46px] text-sm font-normal text-black rounded-lg shadow hover:bg-gray-100 focus:outline-none"
            onClick={() => onClose()}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 w-[113px] h-[46px] text-sm font-normal text-white rounded-lg shadow hover:bg-gray-700 focus:outline-none ${
              selectedType ? "bg-black" : "bg-gray-300"
            }`}
            onClick={handleSelect}
            disabled={!selectedType}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectGreetingType;
